exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!@assets/less/common.less"), "");

// module
exports.push([module.id, "\n.goods-thumb[data-v-7831dc57] { width: 50px; height: 50px; -o-object-fit: cover; object-fit: cover; border-radius: 4px; border: 1px solid #eee;\n}\n", ""]);

// exports
